import cAppeared from './components/c-appeared';
import cAuthReturn from './components/c-auth-return';
import cCustomSelect from './components/c-custom-select';
import cOutline from './components/c-outline';
import preloader from './components/c-preloader';
import header from './blocks/header';
import { bindGlobalInteractionTracking } from './utils/gtm-interactions';

cAppeared();
cAuthReturn();
cCustomSelect();
cOutline();
preloader();
header();
bindGlobalInteractionTracking();
